module.exports = __webpack_public_path__ + "img/ico_user.84df43f1.svg";